module.exports = __webpack_public_path__ + "static/img/zzrz07.efc4737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzrz07.jpg
// module id = wKY5
// module chunks = 1